import { ReactNode } from "react";

import { colors } from "@dotnet/telematics-design-system";

import { TOGGLE_SWITCH_LABEL_PLACEMENT, TOGGLE_SWITCH_SIZES } from "./types";

export const generateLabelRightMargin = (
  labelPlacement?: TOGGLE_SWITCH_LABEL_PLACEMENT,
  endItem?: ReactNode
) => {
  if (endItem && labelPlacement === TOGGLE_SWITCH_LABEL_PLACEMENT.End) {
    return "12px";
  }
  return "0";
};

export const generateLabelLeftMargin = (
  labelPlacement?: TOGGLE_SWITCH_LABEL_PLACEMENT,
  startItem?: ReactNode
) => {
  if (startItem && labelPlacement === TOGGLE_SWITCH_LABEL_PLACEMENT.Start) {
    return "12px";
  }
  return "0";
};

export const toggleSwitchLabelStyles = (
  labelPlacement?: TOGGLE_SWITCH_LABEL_PLACEMENT,
  endItem?: ReactNode,
  startItem?: ReactNode,
  label?: string
) => {
  return {
    alignItems: "center",
    color: colors.textDark,
    marginRight: generateLabelRightMargin(labelPlacement, endItem),
    marginLeft: generateLabelLeftMargin(labelPlacement, startItem),

    "& .MuiTypography-root": {
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0.1px",
      wordBreak: "break-all",
      marginLeft: label && !labelPlacement ? "12px" : "unset"
    },
    "& .MuiFormControlLabel-label.Mui-disabled": {
      opacity: 1,
      color: colors.gray400
    }
  };
};

export const startEnditemsAlignment = {
  display: "flex",
  alignSelf: "flex-start"
};

export const generateToggleSwitchMargins = (
  marginTop: string,
  labelPlacement?: TOGGLE_SWITCH_LABEL_PLACEMENT
) => {
  if (labelPlacement === TOGGLE_SWITCH_LABEL_PLACEMENT.End) {
    return `${marginTop} 12px 0 0`;
  } else if (labelPlacement === TOGGLE_SWITCH_LABEL_PLACEMENT.Start) {
    return `${marginTop} 0 0 12px`;
  }
  return `${marginTop} 0 0 0`;
};

export const generateStartItemMargin = (
  label?: string,
  labelPlacement?: TOGGLE_SWITCH_LABEL_PLACEMENT
) => {
  if (label && labelPlacement === TOGGLE_SWITCH_LABEL_PLACEMENT.Start) {
    return "unset";
  }
  return "12px !important";
};

export const generateEndItemMargin = (
  label?: string,
  labelPlacement?: TOGGLE_SWITCH_LABEL_PLACEMENT
) => {
  if (label && labelPlacement === TOGGLE_SWITCH_LABEL_PLACEMENT.End) {
    return "unset";
  }
  return "12px !important";
};

interface CustomSwitchProps {
  size: any;
  sizes: any;
  labelPlacement: TOGGLE_SWITCH_LABEL_PLACEMENT | undefined;
}

export const generateCustomSwitchStyle = ({
  size,
  sizes,
  labelPlacement
}: CustomSwitchProps) => {
  const rootWidth = sizes[size].rootWidth;
  const rootHeight = sizes[size].rootHeight;
  const thumbCheckedTransform = sizes[size].thumbCheckedTransform;

  return {
    width: rootWidth,
    height: rootHeight,
    padding: 0,
    display: "flex",
    margin:
      size === TOGGLE_SWITCH_SIZES.Small
        ? generateToggleSwitchMargins("2px", labelPlacement)
        : generateToggleSwitchMargins("0", labelPlacement),
    alignSelf: "start",

    "& .MuiSwitch-switchBase": {
      padding: 1,
      transform: "translateY(0)", // ensures no vertical droop
      "&.Mui-checked": {
        transform: thumbCheckedTransform,
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: colors.blue700
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          backgroundColor: colors.gray400,
          opacity: 1
        }
      },
      "&.Mui-disabled": {
        "& + .MuiSwitch-track": {
          backgroundColor: colors.gray400,
          opacity: 1
        }
      }
    },
    "& .MuiSwitch-track": {
      borderRadius: "50px",
      opacity: 1,
      backgroundColor: colors.blue400,
      boxSizing: "border-box"
    }
  };
};
